<div class="content-area">
	<div class="wrap">
		<div class="opaque">
			<carousel id="mycarousel" class="mycarousel"


	            [arrows]="true"
	            [arrowsOutside]="true"
			    [autoplay]="true"
			    [loop]="true"
			    [autoplayInterval]="4000"
			    [transitionDuration]="400"
			    [pauseOnHover]="true"
			    [overflowCellsLimit]="1"
				>
				<div class="carousel-cell">
					<a href="../../../../assets/img/exito/pdf/baterias.pdf" target="_blank">
						<img class="baterias-color" src="../../../../assets/img/logos/baterias-color.png">
					</a>
				</div>
				<div class="carousel-cell">
					<a href="../../../../assets/img/exito/pdf/gala.pdf" target="_blank">
						<img class="gala-color" src="../../../../assets/img/logos/gala-color.webp">
					</a>	
				</div>
				<div class="carousel-cell">
					<a href="../../../../assets/img/exito/pdf/roots.pdf" target="_blank">
						<img class="roots-color" src="../../../../assets/img/logos/roots-color.png">
					</a>
				</div>
				<div class="carousel-cell">
					<a href="../../../../assets/img/exito/pdf/FRAICHE.pdf" target="_blank">
						<img class="fraiche-color" src="../../../../assets/img/logos/fraiche-color.jpg">
					</a>
				</div>
				<div class="carousel-cell">
					<a href="../../../../assets/img/exito/pdf/epasa.pdf" target="_blank">
						<img class="epasa-color" src="../../../../assets/img/logos/epasa-color.webp">
					</a>
				</div>
				<div class="carousel-cell">
					<a href="../../../../assets/img/exito/pdf/hyundai.pdf" target="_blank">
						<img class="hyundai-color" src="../../../../assets/img/logos/hyundai-color.png">
					</a>
				</div>
				<div class="carousel-cell">
					<a href="../../../../assets/img/exito/pdf/sla.pdf" target="_blank">
						<img class="sportline-color" src="../../../../assets/img/logos/sportline-color.webp">
					</a>
				</div>
				<div class="carousel-cell">
					<a href="../../../../assets/img/exito/pdf/plastiglas.pdf" target="_blank">
						<img class="plastiglas-color" src="../../../../assets/img/logos/plastiglas-color.webp">
					</a>
				</div>
				<div class="carousel-cell">
					<a href="../../../../assets/img/exito/pdf/calle.pdf" target="_blank">
						<img class="arturoCalle-color" src="../../../../assets/img/logos/ArturoCalle-color.png">
					</a>
				</div>
				<div class="carousel-cell">
					<a href="../../../../assets/img/exito/pdf/oliveira.pdf" target="_blank">
						<img class="casaOliveira-color" src="../../../../assets/img/logos/CasaOliveira-color.webp">
					</a>
				</div>
				<div class="carousel-cell">
					<a href="../../../../assets/img/exito/pdf/sercoinfal.pdf" target="_blank">
						<img class="sercoinfal-color" src="../../../../assets/img/logos/sercoinfal-color.webp">
					</a>
				</div>
				<div class="carousel-cell">
					<a href="../../../../assets/img/exito/pdf/pendulum.pdf" target="_blank">
						<img class="pendulum-color" src="../../../../assets/img/logos/pendulum-color.webp">
					</a>
				</div>
				<div class="carousel-cell">
					<a href="../../../../assets/img/exito/pdf/naranjax.pdf" target="_blank">
						<img class="naranjax-color" src="../../../../assets/img/logos/naranjax-color.webp">
					</a>
				</div>
				<div class="carousel-cell">
					<a href="../../../../assets/img/exito/pdf/navent.pdf" target="_blank">
						<img class="navent-color" src="../../../../assets/img/logos/navent-color.png">
					</a>
				</div>
				<div class="carousel-cell">
					<a href="../../../../assets/img/exito/pdf/lamper.pdf" target="_blank">
						<img class="lamper-color" src="../../../../assets/img/logos/mclamper.png">
					</a>
				</div>
				<div class="carousel-cell">
					<a href="https://workspace.google.com/customers/quimmco.html" target="_blank">
						<img class="quimmco-color" src="../../../../assets/img/logos/mquimmco.webp">
					</a>
				</div>
				<div class="carousel-cell">
					<a href="../../../../assets/img/exito/pdf/bni.pdf" target="_blank">
						<img class="bni-color" src="../../../../assets/img/logos/mbni.png">
					</a>
				</div>
				<div class="carousel-cell">
					<a href="../../../../assets/img/exito/pdf/sugar.pdf" target="_blank">
						<img class="nicaraguaSugar-color" src="../../../../assets/img/logos/nicaraguaSugar-color.webp">
					</a>
				</div>
				<div class="carousel-cell">
					<a href="../../../../assets/img/exito/pdf/publicidad.pdf" target="_blank">
						<img class="publicidad-color" src="../../../../assets/img/logos/pubcomercial.webp">
					</a>
				</div>
				<div class="carousel-cell">
					<a href="../../../../assets/img/exito/pdf/alqueria.pdf" target="_blank">
						<img class="alqueria-color" src="../../../../assets/img/logos/alqueria-color.webp">
					</a>
				</div>
				<div class="carousel-cell">
					<a href="../../../../assets/img/exito/pdf/hornitos.pdf" target="_blank">
						<img class="hornitos-color" src="../../../../assets/img/logos/hornitos-color.webp">
					</a>
				</div>
				<div class="carousel-cell">
					<a href="../../../../assets/img/exito/pdf/pit.pdf" target="_blank">
						<img class="pit-color" src="../../../../assets/img/logos/pit-color.png">
					</a>
				</div>
				<div class="carousel-cell">
					<a href="../../../../assets/img/exito/pdf/ruz.pdf" target="_blank">
						<img class="ruz-color" src="../../../../assets/img/logos/ruz.webp">
					</a>
				</div>
				<div class="carousel-cell">
					<a href="../../../../assets/img/exito/pdf/barbieri.pdf" target="_blank">
						<img class="barbieri-color" src="../../../../assets/img/logos/barbieri.webp">
					</a>
				</div>
				<div class="carousel-cell">
					<a href="../../../../assets/img/exito/pdf/simpa.pdf" target="_blank">
						<img class="simpa-color" src="../../../../assets/img/logos/simpa.webp">
					</a>
				</div>
			</carousel>
		</div>
	</div>
</div>
